export const initialState = {
  data: {},
  status: null,
  error: false,
  isFetched: false,
  isFetching: false,
  messages: {}
}

export const ACTION_TYPES = {
  CUSTODY_INVESTMENTS_REQUEST: 'CUSTODY_INVESTMENTS_REQUEST',
  CUSTODY_INVESTMENTS_SUCCESS: 'CUSTODY_INVESTMENTS_SUCCESS',
  CUSTODY_INVESTMENTS_ERROR: 'CUSTODY_INVESTMENTS_ERROR',
  CUSTODY_INVESTMENTS_CLEAR: 'CUSTODY_INVESTMENTS_CLEAR'
}

export const getCustodyInvestments = (payload = {}) => ({
  type: ACTION_TYPES.CUSTODY_INVESTMENTS_REQUEST,
  payload
})

export const clearCustodyInvestments = () => ({
  type: ACTION_TYPES.CUSTODY_INVESTMENTS_CLEAR
})

const custodyInvestments = (state = initialState, { type, payload }) => {
  switch (type) {
    case ACTION_TYPES.CUSTODY_INVESTMENTS_REQUEST:
      return {
        ...state,
        isFetching: true
      }
    case ACTION_TYPES.CUSTODY_INVESTMENTS_SUCCESS:
      return {
        ...state,
        status: payload.status,
        data: payload.data,
        error: false,
        isFetched: true,
        isFetching: false,
        messages: payload.messages
      }
    case ACTION_TYPES.CUSTODY_INVESTMENTS_ERROR:
      return {
        ...state,
        status: payload.status,
        error: true,
        errorCode: payload.data && payload.data.Error && payload.data.Error.Code,
        isFetched: true,
        isFetching: false
      }
    case ACTION_TYPES.CUSTODY_INVESTMENTS_CLEAR:
      return {
        ...initialState
      }
    default:
      return state
  }
}

export default custodyInvestments
